import Cookies from 'js-cookie';
import { getAuthorizationHeader, clearSession } from '../services/authService';
import { canAccess as canAccessModule } from '../services/permissionService';
import { parseApiDate, serializeDateForApi, formatDisplayDate } from '../services/dateUtils';
import { apiFetch, getApiErrorMessage, isApiError } from '../services/apiClient';

export { getAuthorizationHeader, parseApiDate, serializeDateForApi, formatDisplayDate, apiFetch, getApiErrorMessage, isApiError };

export const RedirectToLogin = () => {
    clearSession();
};

export const ReturnUserName = () => Cookies.get('username');

export const canAccess = (modulo) => canAccessModule(modulo);
